import { render } from "./AddCustomerDialog.vue?vue&type=template&id=164502c8&scoped=true&ts=true"
import script from "./AddCustomerDialog.vue?vue&type=script&lang=ts"
export * from "./AddCustomerDialog.vue?vue&type=script&lang=ts"

import "./AddCustomerDialog.vue?vue&type=style&index=0&id=164502c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164502c8"]])

export default __exports__